import "core-js/modules/es.number.constructor.js";
import { DEFAULT_ITEMS_PER_PAGE } from 'utils/pagination';
var BASE_USERS_KEY = 'users';
var usersKeys = {
  users: [BASE_USERS_KEY],
  usersQuery: function usersQuery(query) {
    return [BASE_USERS_KEY, query];
  },
  singleUser: function singleUser(id) {
    return [BASE_USERS_KEY, 'single', Number(id)];
  },
  singleUserDetails: function singleUserDetails(userId, teamId) {
    return [BASE_USERS_KEY, 'single', Number(userId), 'details', Number(teamId)];
  },
  singleUserAnalysis: function singleUserAnalysis(userId, weekCommencingDate) {
    return [BASE_USERS_KEY, 'single', Number(userId), 'analysis', weekCommencingDate || 'latest'];
  },
  singleUserMeetingAnalysis: function singleUserMeetingAnalysis(meetingId, userId) {
    return [BASE_USERS_KEY, 'single', Number(userId), 'analysis', 'meeting', Number(meetingId)];
  },
  singleUserSkillAnalysis: function singleUserSkillAnalysis(skillId, userId, weekCommencingDate) {
    return [BASE_USERS_KEY, 'single', Number(userId), 'analysis', 'skill', Number(skillId), weekCommencingDate || 'latest'];
  },
  singleUserAnalysisWeeks: function singleUserAnalysisWeeks(id) {
    return [BASE_USERS_KEY, 'single', Number(id), 'analysis', 'weeks'];
  },
  singleUserAnalysisSkills: function singleUserAnalysisSkills(_ref) {
    var skillId = _ref.skillId,
      userId = _ref.userId,
      weekCommencingDate = _ref.weekCommencingDate,
      _ref$limit = _ref.limit,
      limit = _ref$limit === void 0 ? DEFAULT_ITEMS_PER_PAGE : _ref$limit,
      _ref$offset = _ref.offset,
      offset = _ref$offset === void 0 ? 0 : _ref$offset;
    return [BASE_USERS_KEY, 'single', Number(skillId), Number(userId), 'analysis', 'skills', weekCommencingDate || 'latest', Number(limit), Number(offset)];
  },
  usersSearch: function usersSearch(query) {
    return [BASE_USERS_KEY, query];
  },
  paginatedUsers: function paginatedUsers(search, page, limit) {
    return [BASE_USERS_KEY, 'paginated', search, page, limit];
  },
  singleUserAnalysisSkillsContent: function singleUserAnalysisSkillsContent(_ref2) {
    var skillId = _ref2.skillId,
      userId = _ref2.userId,
      limit = _ref2.limit,
      offset = _ref2.offset;
    return [BASE_USERS_KEY, 'single', Number(skillId), Number(userId), 'analysis', 'skills', 'content', Number(limit), Number(offset)];
  },
  helixAccess: function helixAccess(id) {
    return [BASE_USERS_KEY, 'single', id || (id = 'me'), 'helixAccess'];
  }
};
export default usersKeys;